import { get } from 'lodash';

import MoConstants from '@/online-merchant-onboarding/utils/globalConstant';

import {
	SERVICE_LINE_LIST_REQUESTING,
	SERVICE_LINE_LIST_SUCCESS,
	SERVICE_LINE_LIST_ERROR,
} from './type';

const { PAYMENT_SOLUTION_STATUS, PAYMENT_SOLUTION } = MoConstants;

export const initialState = {
	serviceLineList: [],
	isB2bPgActivated: false,
};

function onboarding(state = initialState, action) {
	switch (action.type) {
		case SERVICE_LINE_LIST_REQUESTING:
			return { ...state, serviceLineList: [] };
		case SERVICE_LINE_LIST_SUCCESS:
			const serviceLine = get(action, 'data', []);
			const pgSolution = serviceLine.find(
				(ps) => ps.type === PAYMENT_SOLUTION.B2B_PG,
			);
			const isB2bPgActivated =
				pgSolution?.status === PAYMENT_SOLUTION_STATUS.SUCCESS;
			return { ...state, serviceLineList: [...serviceLine], isB2bPgActivated };
		case SERVICE_LINE_LIST_ERROR:
			return { ...state, serviceLineList: [] };
		default:
			return state;
	}
}

export default onboarding;
